import ReactGA from 'react-ga';
import { getSecurityContext } from '../selectors/selectors';
import { clearStorage } from '../security/authDucks';

/**
 * Tracks in Google Analytics the current page.
 *
 * @param location The current React-Router location.
 * @param category The document category (optional)
 */
export const trackPageView = (location, category) => {
  if (category) {
    ReactGA.set({ dimension4: category });
  }
  ReactGA.pageview(
    location.pathname + (location.search ? location.search : '')
  );
  ReactGA.set({ dimension4: null });
};

/**
 * Changes the HTML page title according to the given title.
 *
 * @param title The new page title.
 */
export const changePageTitle = (title) => {
  document.title = title;
};

/**
 * Redirects the user if it is not authenticated or not active.
 * Otherwise, the asked transition proceeds.
 *
 * @param nextState The next router state.
 * @param replace A function to trigger a transition to a different URL.
 * @param next A function to call for the transition to proceed.
 * @param store The Redux store.
 */
export const redirectIfNotAuthorized = (nextState, replace, next, store) => {
  console.log('Redirecting unauthorized user');
  let promise = Promise.resolve();
  const securityContext = getSecurityContext(store.getState());
  if (!securityContext.active || !securityContext.authenticated) {
    promise = clearStorage();
    replace({
      pathname: '/sandbox',
    });
  }

  next();

  return promise;
};

/**
 * Redirects the user if it is authenticated.
 * Otherwise, the asked transition proceeds.
 *
 * @param nextState The next router state.
 * @param replace A function to trigger a transition to a different URL.
 * @param next A function to call for the transition to proceed.
 * @param store The Redux store.
 */
export const redirectAuthenticated = (nextState, replace, next, store) => {
  const securityContext = getSecurityContext(store.getState());
  if (securityContext.authenticated && securityContext.active) {
    replace({
      pathname: '/',
    });
  }

  next();
};



// WEBPACK FOOTER //
// ./book/src/commons/routes/routeHooks.js